/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsMartialArtsIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-martial-arts"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M13.57 12.22L13.1 22.18Q13.07 22.7 12.69 23.05Q12.3 23.4 11.68 23.4Q11.15 23.4 10.78 23.05Q10.4 22.7 10.38 22.18L9.93 13.28L6.78 11.5L6.58 12.25L8.05 14.8Q8.32 15.28 8.19 15.81Q8.05 16.35 7.55 16.63Q7.08 16.9 6.54 16.75Q6 16.6 5.72 16.13L3.98 13.1Q3.85 12.88 3.81 12.61Q3.77 12.35 3.85 12.07L4.97 8.05L10.47 4.9L8.72 3.15Q8.35 2.77 8.34 2.24Q8.32 1.7 8.72 1.3Q9.1 0.93 9.65 0.93Q10.2 0.93 10.57 1.3L13.55 4.25Q14.03 4.72 13.94 5.38Q13.85 6.03 13.28 6.35L11.2 7.53L12.35 8.35L19.68 2.38Q20.07 2.05 20.57 2.13Q21.07 2.2 21.48 2.65Q21.8 3 21.77 3.48Q21.75 3.95 21.4 4.3ZM4.75 7.25Q3.83 7.25 3.16 6.59Q2.5 5.92 2.5 5Q2.5 4.05 3.16 3.4Q3.83 2.75 4.75 2.75Q5.7 2.75 6.35 3.4Q7 4.05 7 5Q7 5.92 6.35 6.59Q5.7 7.25 4.75 7.25Z" fill={color} />
    </svg>
  );
}
